/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this safe for passwords or security keys?`)
};

const es_rg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es esto seguro para contraseñas o claves de seguridad?`)
};

const de_rg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist dies sicher für Passwörter oder Sicherheitsschlüssel?`)
};

const nl_rg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is dit veilig voor wachtwoorden of beveiligingssleutels?`)
};

const fr_rg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est-ce sûr pour les mots de passe ou les clés de sécurité ?`)
};

const it_rg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È sicuro per password o chiavi di sicurezza?`)
};

const pt_br2_rg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isso é seguro para senhas ou chaves de segurança?`)
};

const pt_rg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isto é seguro para senhas ou chaves de segurança?`)
};

const ja_rg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードやセキュリティキーに安全ですか？`)
};

const zh_rg_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个工具适合用于生成密码或安全密钥吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_faq4_q", locale)
	if (locale === "en") return en_rg_faq4_q(inputs)
	if (locale === "es") return es_rg_faq4_q(inputs)
	if (locale === "de") return de_rg_faq4_q(inputs)
	if (locale === "nl") return nl_rg_faq4_q(inputs)
	if (locale === "fr") return fr_rg_faq4_q(inputs)
	if (locale === "it") return it_rg_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_rg_faq4_q(inputs)
	if (locale === "pt") return pt_rg_faq4_q(inputs)
	if (locale === "ja") return ja_rg_faq4_q(inputs)
	return zh_rg_faq4_q(inputs)
};